/* eslint-disable import/prefer-default-export */
export function GetNetWorkHeaders(persistItemsReducer = {}) {
    const headers = {
      Authorization: `Bearer ${persistItemsReducer?.accessToken}`,
       SOCode: persistItemsReducer?.selectedSOData?.soCode ,
    };
    console.log("GetNetWorkHeaders", headers);
    return headers;
  }
  